function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import * as R from 'unitx/ramda';
import { useSpring } from 'react-spring';
import { getAnimationConfigByName } from "../animation/registry";

const createAnimationSpring = ({
  to: defaultTo = {},
  from: defaultFrom = {} // @ts-ignore

}) => (props, deps = []) => {
  const {
    from = {},
    to = {}
  } = props,
        restProps = _objectWithoutProperties(props, ["from", "to"]);

  return useSpring(() => _objectSpread({
    to: R.mergeRight(defaultTo, to),
    from: R.mergeRight(defaultFrom, from)
  }, restProps), deps);
}; // type AnimationSituation = Record<string, any>
// type AnimationConfig = Record<string, AnimationSituation> & {
//   easing?: string;
//   from?: AnimationSituation;
//   to?: AnimationSituation;
// }
// export type Animation = <Props extends object>(
//   config?: AnimationProps<Props>
//   ) => [SpringValue<Props>, SpringUpdateFn<Partial<Props>>, SpringStopFn<Props>]


export const createUseAnimation = definition => {
  const {
    // style: ___,
    // easing: __,
    from: fromSituation,
    to: toSituation
  } = definition,
        timeBasedSituations = _objectWithoutProperties(definition, ["from", "to"]);

  const finalTimeBasedSituations = R.pipe(R.when(R.always(R.isNotNil(fromSituation)), R.set(R.lensProp(0), fromSituation)), R.when(R.always(R.isNotNil(toSituation)), R.set(R.lensProp(1), toSituation)))(timeBasedSituations);
  const [from, ...toArray] = R.map(R.prop(1), R.sortBy(R.prop(0), R.toPairs(finalTimeBasedSituations)));
  return createAnimationSpring({
    from,
    to: R.last(toArray)
  });
};
export default ((config, deps = []) => {
  const useSpringAnimation = React.useMemo(() => {
    var _getAnimationConfigBy;

    return createAnimationSpring((_getAnimationConfigBy = getAnimationConfigByName(config === null || config === void 0 ? void 0 : config.name)) !== null && _getAnimationConfigBy !== void 0 ? _getAnimationConfigBy : {});
  }, [config === null || config === void 0 ? void 0 : config.name]);
  const ref = React.useRef(null); // @ts-ignore

  const [props, set, stop] = useSpringAnimation(_objectSpread(_objectSpread({}, config), {}, {
    // @ts-ignore
    ref
  }), deps);
  React.useEffect(() => {
    var _ref$current, _ref$current2;

    (config === null || config === void 0 ? void 0 : config.autoStart) === false ? (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.pause() : (_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.start(); // @ts-ignore

    ref.current.config = config; // @ts-ignore

    ref.current.reverse = (reverseConfig = {
      reversed: true
    }) => {
      var _ref$current5;

      const {
        reversed = true
      } = reverseConfig;

      if (reversed) {
        var _ref$current3;

        (_ref$current3 = ref.current) === null || _ref$current3 === void 0 ? void 0 : _ref$current3.update({
          // @ts-ignore
          from: config === null || config === void 0 ? void 0 : config.to,
          to: config === null || config === void 0 ? void 0 : config.from
        });
      } else {
        var _ref$current4;

        (_ref$current4 = ref.current) === null || _ref$current4 === void 0 ? void 0 : _ref$current4.update({
          from: config === null || config === void 0 ? void 0 : config.from,
          to: config === null || config === void 0 ? void 0 : config.to
        });
      }

      ref === null || ref === void 0 ? void 0 : (_ref$current5 = ref.current) === null || _ref$current5 === void 0 ? void 0 : _ref$current5.start();
    };
  }, deps); // @ts-ignore

  return {
    ref,
    props,
    set,
    stop
  };
});
export { animated } from 'react-spring';